import { defaultModel } from "../core/chat/openai";
import { OptionGroup } from "../core/options/option-group";

export const parameterOptions: OptionGroup = {
    id: "parameters",
    options: [
        {
            id: "model",
            defaultValue: defaultModel,
            resettable: false,
            scope: "user",
            displayOnSettingsScreen: "chat",
            displayAsSeparateSection: true,
            displayInQuickSettings: {
                name: "Model",
                displayByDefault: true,
                label: (value) => value,
            },
            renderProps: (value, options, context) => ({
                type: "select",
                label: context.intl.formatMessage({ defaultMessage: "Model" }),
                options: [
                    {
                        label: context.intl.formatMessage({
                            defaultMessage: "GPT 4",
                        }),
                        value: "gpt-4",
                    },
                    {
                        label: context.intl.formatMessage({
                            defaultMessage: "GPT 3.5 Turbo",
                        }),
                        value: "gpt-3.5-turbo",
                    },
                    {
                        label: context.intl.formatMessage({
                            defaultMessage: "GPT 3.5 Turbo (16k)",
                        }),
                        value: "gpt-3.5-turbo-16k",
                    },
                ],
            }),
        },
        {
            id: "temperature",
            defaultValue: 0.5,
            resettable: true,
            scope: "chat",
            displayOnSettingsScreen: "chat",
            displayAsSeparateSection: true,
            displayInQuickSettings: {
                name: "Temperature",
                displayByDefault: false,
                label: (value, options, context) =>
                    context.intl.formatMessage({
                        defaultMessage: "Temperature",
                    }) +
                    ": " +
                    value.toFixed(1),
            },
            renderProps: (value, options, context) => ({
                type: "slider",
                label:
                    context.intl.formatMessage({
                        defaultMessage: "Temperature",
                    }) +
                    ": " +
                    value.toFixed(1),
                min: 0,
                max: 1,
                step: 0.1,
                description: context.intl.formatMessage({
                    defaultMessage:
                        "The temperature parameter controls the randomness of the AI's responses. Lower values will make the AI more predictable, while higher values will make it more creative.",
                }),
            }),
        },
    ],
};
